module.exports = __webpack_public_path__ + "img/zhi-i1-2.ebe6bf31.jpg";